import { makeStyles } from '@material-ui/styles';

export const useTicketConfirmationStyles = makeStyles(() => ({
  title: {
    fontSize: 26,
    marginTop: 20,
    fontWeight: 600,
  },
  subtitle: {
    fontSize: 16,
    marginTop: 20,
  },
  purpleDetail: {
    color: '#6A148E',
    fontWeight: 600,
    fontSize: 22,
    marginTop: 12,
  },
  bodyText: {
    marginTop: (props) => (props.mobile ? 10 : 25),
    marginBottom: 5,
    fontSize: 16,
  },
}));
